import { Link } from "@tanstack/react-router";
import { motion } from "motion/react";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/download", label: "Download" },
  { to: "/docs", label: "Docs" },
  { to: "/bugs", label: "Bugs" },
];

export function Header() {
  return (
    <header className="z-40 border-white/10 border-b bg-background/50 backdrop-blur-xl">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-start px-5 py-3.5">
        <nav className="flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={cn(
                "relative rounded-full px-3 py-2 text-foreground/70 text-sm transition-colors hover:text-foreground",
                "data-[status=active]:text-foreground",
              )}
              activeProps={{
                "data-status": "active",
              }}
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <motion.span
                      layoutId="nav-pill"
                      className="absolute inset-0 rounded-full bg-white/8"
                      transition={{
                        type: "spring",
                        stiffness: 380,
                        damping: 30,
                      }}
                    />
                  )}
                  <span className="relative z-10">{item.label}</span>
                </>
              )}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
